/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Failed_FetchInputs */

const en_files_failed_fetch = /** @type {(inputs: Files_Failed_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to fetch audios`)
};

const es_files_failed_fetch = /** @type {(inputs: Files_Failed_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar los audios`)
};

/**
* | output |
* | --- |
* | "Failed to fetch audios" |
*
* @param {Files_Failed_FetchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_failed_fetch = /** @type {((inputs?: Files_Failed_FetchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Failed_FetchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_failed_fetch(inputs)
	return en_files_failed_fetch(inputs)
});